module.exports = __webpack_public_path__ + "static/nps-feedback-213a913ad2c6a38b0425d4bc540c90ec.png";